import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { ImageBase } from '../../../image-base';
import { BadgePosition } from '../../enums';
import { BadgeProps } from '../../types';
import css from './style.module.css';

const positionPresets: Record<BadgePosition, string> = {
  [BadgePosition.TOP_LEFT]: css.topLeft,
  [BadgePosition.TOP_CENTER]: css.topCenter,
  [BadgePosition.TOP_RIGHT]: css.topRight,
  [BadgePosition.BOTTOM_LEFT]: css.bottomLeft,
  [BadgePosition.BOTTOM_CENTER]: css.bottomCenter,
  [BadgePosition.BOTTOM_RIGHT]: css.bottomRight,
};

export const Layout = forwardRef<HTMLDivElement, BadgeProps>(function Component(
  { className, position = BadgePosition.BOTTOM_RIGHT, ...props },
  forwardedRef
) {
  return (
    <ImageBase.Badge
      {...props}
      className={clsx(className, positionPresets[position])}
      ref={forwardedRef}
    />
  );
});
